import { httpCreate } from './http';
import { activity } from './activity';

import conf from '@/config';

const baseURL = conf.uploadHost;

const http = httpCreate(conf.apipath + '/upload');
const shopHttp = httpCreate(conf.surveyApipath + '/upload');

export const upload = {
	getToken(storeId, type) {
		return shopHttp.get('/token', {
			params: {
				storeId: storeId ? storeId : 0,
				uploadType: type ? type : 'image',
			},
		});
	},
	async uploadFile(storeId, file, type, config) {
		const { data, ok } = await upload.getToken(storeId ? storeId : 0, type ? type : 'image');
		if (!ok) {
			return;
		}
		const backend = encodeURIComponent(
			`${process.env.NODE_ENV == 'development' ? 'https://beta.tuwenzhibo.com' : conf.host}${conf.surveyApipath}${
				conf.uploadsever
			}`
		);
		return http.post(`/upload/file/image?backend=${backend}`, file, {
			...config,
			baseURL,
			headers: {
				token: data.data.token,
			},
		});
	},
};
